export default "__VITE_ASSET__CIZJBtxu__"